import { UserMessageModel } from "@payping/api";
import { dateFormats, toJalali } from "@payping/utils/dateUtils";
import { webConstants } from "@payping/utils/platformConstants";
import { Row, Typography } from "@payping/web-components";
import classnames from "classnames";
import React from "react";
import { Link } from "react-router-dom";

import styles from "../../../assets/scss/Notifications.module.scss";

interface Props {
  messageList?: UserMessageModel[];
}

const Notifications: React.FC<Props> = (props: Props) => {
  const { messageList } = props;
  return (
    <div className={styles.dropdown}>
      <div className={styles.list}>
        {messageList?.map((msg, index) => (
          <div key={index} className={classnames(styles.item, !msg.isSeen && styles.notSeen)}>
            <Link to={webConstants.DashboardRoutes.home.messages}>
              <Row justify={"space-between"} className="color--primaryLite">
                <Typography.Text variant={"body2"} strong>
                  {msg.title}
                </Typography.Text>
                <Typography.Text className="font-em-8">
                  {toJalali({ date: msg.createdDateTime, toFormat: dateFormats.ui.jalaliDate }).string}
                </Typography.Text>
              </Row>
            </Link>
            <Typography.Paragraph className="font-em-9" ellipsis>
              {msg.description}
              <br />
              {msg.link ? (
                <a href={msg.link} target={"_blank"} rel={"noreferrer"}>
                  {msg.link}
                </a>
              ) : null}
            </Typography.Paragraph>
          </div>
        ))}
      </div>
      <Link to={webConstants.DashboardRoutes.home.messages}>
        <div className={styles.footer}>همه اعلانات</div>
      </Link>
    </div>
  );
};

export default Notifications;
